<div class="onboarding-step-wrapper">
    <h2>Financial dates</h2>
    <div class="onboarding-blurb">
        <p>
            You may set the default financial reporting period and payment interval for your organisation here.
        </p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <form [formGroup]="financialForm" class="cas-flex-column">
                <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
                    <!-- <div class="cas-form-block-title">Reporting</div> !-->
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Reporting period</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-dropdown
                                    appendTo="body"
                                    formControlName="period"
                                    [options]="periods"
                                    placeholder="Select Period"
                                    optionLabel="name"></p-dropdown>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Reporting Start Date</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-calendar
                                    formControlName="startDate"
                                    dateFormat="dd/mm/y"
                                    appendTo="body"
                                    readonlyInput="true"
                                    #calendar></p-calendar>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </acabim-form-block>
                <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
                    <!-- <div class="cas-form-block-title">Payments</div> !-->
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Payment Interval</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-dropdown
                                    appendTo="body"
                                    formControlName="interval"
                                    [options]="intervalTypes"
                                    placeholder="Select Interval"
                                    optionLabel="name"></p-dropdown>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Payment Interval amount</acabim-form-input-label>
                        <acabim-form-input-content [exShortField]="true">
                            <input type="number" formControlName="intervalValue" />
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </acabim-form-block>
                <button (click)="submit(true)" class="cas-button-action">Update</button>
            </form>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>
